// Redux action types
export const SET = 'one-state-timeslots-athena/set';
export const REINIT = 'one-state-timeslots-athena/reinit';

